import {
  Dropdown, DropdownItem, DropdownMenu, DropdownTrigger,
} from '@heroui/react';
import {
  AlignLeft,
  BookText,
  ChevronDown,
} from 'lucide-react';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

import shortLogo from '../../../assets/images/short-hs-logo.svg?url';
import { usePermissions } from '../../../hooks';
import { useAuthState } from '../../../state';
import { Flex } from '../../Flex';
import { Breadcrumbs } from '../Breadcrumbs';
import { NotificationsBell } from './NotificationsBell';
import {
  MobileNavigationHeadline,
  RightNav,
  TopBarWrapper,
} from './TopBar.styled';

interface TopBarProps {
    showMobileNavigation: () => void;
}

export const TopBar: FC<TopBarProps> = (props) => {
  const { showMobileNavigation } = props;
  const { logout, currentUser } = useAuthState();
  // Konto z zawężeniem `onlyAttraction` nie ma po co dostawać powiadomień —
  // dotyczą obszarów, do których i tak nie ma dostępu.
  const { isOnlyAttraction } = usePermissions();
  const navigate = useNavigate();

  // Use first name and last name, fallback to displayName or email prefix
  const userName = currentUser?.name && currentUser?.surname
    ? `${currentUser.name} ${currentUser.surname}`
    : currentUser?.displayName || currentUser?.email?.split('@')[0] || 'User';

  return (
    <TopBarWrapper>
      <MobileNavigationHeadline onClick={showMobileNavigation}>
        <Flex itemAlign="center" justifyContent="center" height="100%">
          <AlignLeft />
          <ReactSVG src={shortLogo} shapeRendering={2} />
        </Flex>
      </MobileNavigationHeadline>
      <Breadcrumbs />
      <RightNav>
        <button
          type="button"
          aria-label="Dokumentacja API"
          title="Dokumentacja API"
          onClick={() => window.open('https://hotelspot-api.web.app/', '_blank', 'noopener,noreferrer')}
          className="flex items-center cursor-pointer hover:opacity-70 transition-opacity bg-transparent border-0 p-0 text-gray-600"
        >
          <BookText size={20} />
        </button>
        {!isOnlyAttraction && <NotificationsBell />}
        <Dropdown placement="bottom-start">
          <DropdownTrigger>
            <div className="flex items-center gap-2 cursor-pointer hover:opacity-70 transition-opacity">
              <span className="text-sm font-medium">{userName}</span>
              <ChevronDown size={16} className="text-gray-500" />
            </div>
          </DropdownTrigger>
          <DropdownMenu aria-label="User Actions" variant="flat">
            <DropdownItem key="profile" onPress={() => navigate('/profile')}>My Profile</DropdownItem>
            <DropdownItem key="logout" color="danger" onPress={() => logout()}>
              Log Out
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </RightNav>
    </TopBarWrapper>
  );
};
